import { z } from "zod";

export const recordId = z.string().uuid();

export const partyKind = z.enum(["vendor", "customer", "subcontractor", "worker"]);
export type PartyKind = z.infer<typeof partyKind>;

export const membershipRole = z.enum(["admin", "propertyManager", "member"]);
export type MembershipRole = z.infer<typeof membershipRole>;

export const membershipStatus = z.enum(["active", "suspended", "pending", "invited"]);
export type MembershipStatus = z.infer<typeof membershipStatus>;

export const membership = z.object({
  organizationId: recordId,
  organizationName: z.string(),
  kind: partyKind,
  role: membershipRole,
});

export const contactProperty = z.object({ id: recordId, name: z.string() });
export type ContactProperty = z.infer<typeof contactProperty>;

export const me = z.object({
  authId: z.string(),
  userId: recordId.nullable(),
  email: z.string().nullable(),
  memberships: z.array(membership),
  contactProperties: z.array(contactProperty).default([]),
});
export type Me = z.infer<typeof me>;

export const myOrganization = z.object({
  id: recordId,
  name: z.string(),
  kind: partyKind,
  logo: z.string().nullable(),
  role: membershipRole,
  status: membershipStatus,
});
export type MyOrganization = z.infer<typeof myOrganization>;

export const myOrganizations = z.object({ items: z.array(myOrganization) });
export type MyOrganizations = z.infer<typeof myOrganizations>;

export const health = z.object({ ok: z.literal(true), service: z.literal("api"), photoUploads: z.boolean(), commit: z.string().nullable() });
export type Health = z.infer<typeof health>;

export const apiErrorCode = z.enum(["unauthenticated", "not_found", "forbidden", "wrong_status", "checklist_incomplete", "not_assigned", "cancellation_cutoff", "go_back_window_closed", "invoiced", "invalid", "no_price", "reason_required", "no_chat_room", "no_billing_email", "storage_unavailable", "payments_unavailable", "not_ready_for_payouts", "amount_changed", "payment_in_progress", "no_saved_payment_method", "payment_declined", "last_admin", "role_not_offered", "not_joined", "already_linked", "already_contracted", "already_assigned", "not_convertible", "no_such_person", "no_such_subcontractor", "in_use", "rate_limited", "auth_unavailable", "already_signed_up", "already_invited", "invite_not_sent", "writes_held", "internal"]);
export type ApiErrorCode = z.infer<typeof apiErrorCode>;

export const apiError = z.object({
  error: z.object({
    code: apiErrorCode,
    message: z.string(),
  }),
});
export type ApiErrorBody = z.infer<typeof apiError>;
